/*
 *   Copyright (c) 2021 vlinder Labs Private Limited
 *   All rights reserved.
 *   This software is proprietary of Vlinder Labs Pvt. Ltd and can not be distributed / used for any purpose outside of Vlinder Labs Pvt. Ltd without explicit written consent from the copyright owner.
 */

export const DEFAULT_APP_CONFIG = {
  servers: {
    graphql: [
      {
        name: "graphql-gateway",
        url: "https://dev-dc.vlinder.io/vlinder-core/",
      },
    ],
    rest: {
      loginServer: {
        baseURL: "https://dev-dc.vlinder.io/vlinder-login/",
      },
    },
  },
  defaultLoading: {
    image:
      "https://s3.ap-south-1.amazonaws.com/io.vlinder.klefki/klefki-blue-200.png",
    titleNormalText: "Loading",
    titleBoldText: "Page...",
    description: "This might take few seconds, Please wait !",
  },
  platformSemantics: {
    semantics: {
      holder: "Student",
      holders: "Students",
      issuer: "Organization",
    },
    Holders: {
      title: "Students",
    },
    HoldersGroups: {
      title: "Students Group",
    },
    DashboardIssuerAnalysis: {
      title: "Organization",
    },
  },
};
